import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bf-modal bf-modal--has-sections" }
const _hoisted_2 = { class: "bf-modal__section" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = { class: "d-flex justify-content-between" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "bf-heading-display text-body mb-3" }, "Meine Be­stel­lun­gen", -1)
const _hoisted_6 = { class: "flex-shrink-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "mt-5 text-center"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-3x fa-spin fa-spinner" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "d-none d-md-table-row" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Datum"),
    /*#__PURE__*/_createElementVNode("th", null, "Bestellnummer"),
    /*#__PURE__*/_createElementVNode("th", null, "Summe"),
    /*#__PURE__*/_createElementVNode("th", null, " ")
  ])
], -1)
const _hoisted_14 = { class: "d-md-none" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "d-none d-md-table-cell text-nowrap" }
const _hoisted_17 = { class: "d-none d-md-table-cell text-break" }
const _hoisted_18 = { style: {"vertical-align":"middle"} }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Rechnung ")
const _hoisted_21 = {
  href: "#",
  ref: "downloadLink",
  target: "_blank",
  style: {"display":"none"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    modelValue: _ctx.shownLocal,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.shownLocal) = $event)),
    close: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("a", {
                  href: "#",
                  class: "modal-close-button",
                  "aria-label": "Schließen",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["prevent"]))
                }, _hoisted_8)
              ])
            ])
          ]),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.orders.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("table", null, [
                        _hoisted_13,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orders, (order) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: order.id
                            }, [
                              _createElementVNode("td", null, [
                                _createTextVNode(_toDisplayString(_ctx.formatDate(order.created_at)) + " ", 1),
                                _createElementVNode("div", _hoisted_14, [
                                  _createElementVNode("b", null, _toDisplayString(order.order_number), 1),
                                  _hoisted_15,
                                  _createTextVNode(" " + _toDisplayString(order.amount_human_with_currency), 1)
                                ])
                              ]),
                              _createElementVNode("td", _hoisted_16, _toDisplayString(order.order_number), 1),
                              _createElementVNode("td", _hoisted_17, _toDisplayString(order.amount_human_with_currency), 1),
                              _createElementVNode("td", _hoisted_18, [
                                _createElementVNode("a", {
                                  href: "#",
                                  class: "text-nowrap",
                                  onClick: _withModifiers(($event: any) => (_ctx.downloadInvoice(order)), ["prevent"])
                                }, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(["fas fa-fw", {'fa-download': !order.loading, 'fa-spinner fa-spin': order.loading}])
                                  }, null, 2),
                                  _hoisted_20
                                ], 8, _hoisted_19)
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 64)),
          _createElementVNode("a", _hoisted_21, null, 512)
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "close"]))
}